export default __webpack_public_path__ + "static/media/blog1_2.7c769670.png";